<template>
  <button
    class="base-button"
    :class="{ disabled: isDisabled }"
    :disabled="isDisabled"
  >
    <img :src="iconSrc" :alt="type" class="icon-arrow" />
  </button>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "PrevNextButton",
  props: {
    type: {
      type: String as () => "Prev" | "Next",
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const iconMap: Record<string, string> = {
      Prev: require("@/assets/icons/Prev.svg"),
      Next: require("@/assets/icons/Next.svg"),
    };

    const iconSrc = computed(() => iconMap[props.type]);

    return { iconSrc };
  },
});
</script>

<style scoped lang="scss">
@import "src/styles/commons/controls/prevNextButton";
</style>
